import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { Contact } from '@epicuro-next/models/contacts';

@Component({
  selector: 'atx-business-contacts',
  templateUrl: './business-contacts.component.html',
  styleUrls: ['./business-contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BusinessContactsComponent {
  @ContentChild('contactsList', { static: false })
  protected contactsListTemplateRef?: TemplateRef<unknown>;

  @Input() public contacts: Contact[] = [];
  @Input() public hyperlinkEmail = false;
  @Input() public showShowAllButton = false;
  @Input() public isLoading = false;

  @Output() public readonly showAll = new EventEmitter();

  protected showAllClicked(): void {
    this.showAll.emit();
  }
}
